/**
 * Dev environment configuration for stress testing.
 * DO NOT commit this file with real tokens.
 * In production, tokens come from auth flow.
 */

export const DEV_CONFIG = {
  baseUrl: 'https://dev-api.scrips.com',
  organizationId: '1d8ce992-985f-ea11-a94c-000d3af00364',
  practiceId: '398e77c0-9a5f-ea11-9192-0cc47a65f3a3',
  tenant: 'demo',
  // OAuth client this app authenticates as. Sourced from build-time env so the
  // legacy Flutter app and this app can hold DISTINCT client ids — Scrips.Identity
  // gates per-organization app access on client_id (dbo.OrganizationAppAccess), and
  // that gate cannot tell the two apps apart while they share one. See
  // Scrips.Identity → AppSurfaceMap.
  //
  // Defaults to Scrips.Practice.V2 because that is what this app IS. Sharing the
  // legacy "Scrips.Practice" id is what the gate cannot cope with, so the default
  // must not be the legacy value — a build that forgets VITE_AUTH_CLIENT_ID would
  // otherwise silently keep the two apps indistinguishable.
  //
  // Production is pinned back to the legacy id explicitly in prod-web.yml until a
  // Scrips.Practice.V2 client exists in the prod ConfigurationDb.
  //
  // clientSecret is deliberately NOT defaulted: Vite inlines VITE_* into the JS
  // bundle, so a committed secret ships to every browser. Supply it via
  // .env.local locally and the deploy workflow in CI. Login fails with
  // `invalid_client` when unset — loud, rather than silently falling back to a
  // shared credential.
  auth: {
    tokenEndpoint: '/connect/token',
    clientId: (import.meta.env.VITE_AUTH_CLIENT_ID ?? 'Scrips.Practice.V2') as string,
    clientSecret: (import.meta.env.VITE_AUTH_CLIENT_SECRET ?? '') as string,
    scope: 'openid offline_access',
  },
};
